import { DateTime } from "luxon";

type AgentDateValue = string | null | undefined;

/**
 * Parses backend ISO timestamps for agent views.
 *
 * Missing or invalid dates return `null` so callers can choose an explicit
 * fallback for sorting or display.
 */
export const getAgentDateTime = ({ value }: { value: AgentDateValue }) => {
  if (!value) {
    return null;
  }

  const dateTime = DateTime.fromISO(value);
  return dateTime.isValid ? dateTime : null;
};

export const getAgentTimestamp = ({
  value,
  fallback,
}: {
  value: AgentDateValue;
  fallback: number;
}) => getAgentDateTime({ value })?.toMillis() ?? fallback;

export const formatAgentDate = ({
  value,
  includeTime = false,
}: {
  value: AgentDateValue;
  includeTime?: boolean;
}) => {
  const dateTime = getAgentDateTime({ value });

  if (!dateTime) {
    return "—";
  }

  if (includeTime && (dateTime.hour !== 0 || dateTime.minute !== 0)) {
    return dateTime.toFormat("MMM d, h:mma");
  }

  return dateTime.toFormat("MMM d");
};
